import { createContext } from 'react'

import { ClinicContextStoreEventData } from '@surglogs-app/types'

export * from './PermissionsContext'

export type IClinicContext = {
  clinicId: number | null
  clinic: ClinicContextStoreEventData
  changeClinic: (clinicId: number, token?: string | null) => void
  refetchClinicData: () => void
  setClinicId: (clinicId: number, withoutStorageSync?: boolean) => void
  clearClinicData: () => void
}

export const AuthContext = createContext<Auth>({} as Auth)
export const AuthContextProvider = AuthContext.Provider
export const AuthContextConsumer = AuthContext.Consumer
export const ClinicContext = createContext<IClinicContext>({} as IClinicContext)
